import React from 'react';
import { Link } from 'react-router-dom';
import { LoginNavbar } from '../../components/layout/Navbar';

const Footer = ({ className }) => (
  <footer className={className || 'footer'}>
    @ EZ Timesheet Copyright Reserved
  </footer>
);

const PrivacyPolicy = () => {
  return (
    <>
      <LoginNavbar />
      <div className="about-container">
        <div className="about-back-button">
          <Link to="/login" className="back-button">
            ← Back to Login
          </Link>
        </div>
        <div className="about-hero">
          <div className="about-hero-content">
            <h1 className="about-title">Privacy Policy</h1>
            <p className="privacy-policy-updated">Last updated: September 8, 2025</p>
          </div>
        </div>


        <div className="about-content">

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">1. Information We Collect and How We Use It</h2>
              <p className="about-section-text">
                We collect personal information that you provide to us when registering for an account, 
                using our Service, or communicating with us. This includes your full name, email address, 
                contact details, company affiliation, login credentials, and timesheet entries such as 
                work hours, projects, and tasks. Additionally, we automatically gather technical data 
                through your interactions with the Service, including IP address, device information, 
                browser type, usage patterns, and log data.

                The information collected is used primarily to provide, maintain, and improve the Service, 
                manage your account, process timesheet data accurately, and communicate important updates 
                or support information. We may also use your information to develop new features and ensure 
                compliance with legal obligations. Marketing communications will only be sent with your 
                explicit consent, which you may withdraw at any time.
              </p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">2. Sharing, Disclosure, and Security of Your Information</h2>
              <p className="about-section-text">
                We do not sell, rent, or trade your personal data to third parties. Your information may be 
                shared with trusted service providers who assist us in operating the Service, subject to 
                confidentiality agreements and use restrictions solely for service purposes. We may disclose 
                your data if required by law, legal process, or to protect our rights, users, or others from 
                harm.

                We implement appropriate technical, administrative, and organizational safeguards to protect 
                your personal data against unauthorized access, disclosure, alteration, or destruction. Despite 
                these measures, no system is entirely secure, and you acknowledge the inherent risks of 
                transmitting data over the internet.
              </p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">3. Data Retention and Your Rights</h2>
              <p className="about-section-text">
                We retain your personal data only for as long as necessary to fulfill the purposes for which it was 
                collected, comply with legal obligations, resolve disputes, and enforce our agreements. Once the 
                data is no longer required, we securely delete or anonymize it.

                Depending on your jurisdiction, you may have certain rights concerning your personal data, including 
                the right to access, correct, delete, restrict, or object to processing, and to receive your data in 
                a portable format. Where processing is based on your consent, you have the right to withdraw consent 
                at any time without affecting the lawfulness of prior processing. To exercise your rights, please 
                contact us using the information below.
              </p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">4. Cookies and Tracking Technologies</h2>
              <p className="about-section-text">
                EZ Timesheet uses cookies and similar tracking technologies to enhance functionality, analyze usage, 
                and improve user experience. Cookies help us remember your preferences and gather aggregate data on 
                how the Service is used. You can manage or disable cookies through your browser settings; however, 
                doing so may limit certain features or reduce the usability of the Service.
              </p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">5. Children’s Privacy</h2>
              <p className="about-section-text">
                Our Service is not directed at individuals under the age of 13 (or the applicable age in your 
                jurisdiction). We do not knowingly collect personal information from children under this age. If 
                we learn that we have inadvertently collected data from a child under the minimum age, we will promptly 
                delete such information.
              </p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">6. Changes to This Privacy Policy</h2>
              <p className="about-section-text">
                We may update this Privacy Policy from time to time to reflect changes in our practices, technology, 
                or legal requirements. Updated policies will be posted on this page with the revised effective date. 
                Your continued use of the Service after any changes indicates your acceptance of the updated policy.
              </p>
            </div>
          </div>
          
          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">7. Contact Information</h2>
              <p className="about-section-text">
                If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, 
                please contact EZ Timesheet Support at oseelight@gmail.com.
              </p>
            </div>
          </div>

        </div>
      </div>
      <Footer className="about-footer" />
    </>
  );
};

export default PrivacyPolicy;
